import React, { useContext, useEffect, useMemo, useState } from "react";

import { message, Modal } from "antd";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useTranslation } from "react-i18next";

import bus from "@/utils/bus";
import JoinTeam from "./JoinTeam";
function JoinTeamModal() {
  const [visible, setVisible] = useState(false);
  const [teamId, setTeamId] = useState("");
  const { t } = useTranslation("common");
  const { authInfo } = useContext<GlobalContextConfig>(GlobalContext);
  const openJoinTeamModal = (data: { teamId?: string; isGenerate?: boolean }) => {
    console.log("openJoinTeamModal", data);
    const { teamId, isGenerate = true } = data;
    if (!teamId) {
      return;
    }
    setVisible(true);
    if (teamId) {
      setTeamId(teamId);
    }
  };
  const handleClose = () => {
    setVisible(false);
  };
  const doTeamInvite = (userInfo: any) => {
    const teamId = userInfo.selectedTeamId;
    if (localStorage.getItem("openJoinTeamModal" + teamId) === "1") {
      bus.emit("openJoinTeamModal", {
        teamId: teamId
      });
      localStorage.removeItem("openJoinTeamModal" + teamId);
    }
  };
  useEffect(() => {
    if (!authInfo) return;
    bus.on("openJoinTeamModal", openJoinTeamModal);
    doTeamInvite(authInfo);
    return () => {
      bus.off("openJoinTeamModal", openJoinTeamModal);
    };
  }, [authInfo]);
  return (
    <Modal
      visible={visible}
      width={600}
      destroyOnClose={true}
      maskClosable={false}
      onCancel={handleClose}
      centered={true}
      footer={null}
      title={t("createButton.joinTeam")}
      //   getContainer={() => document.querySelector(".appContent") || document.body}
      wrapClassName="share-group-modal-wrapper"
    >
      <JoinTeam teamId={teamId} />
    </Modal>
  );
}

export default JoinTeamModal;
